export class GuestTokenInvalid extends Error {
  constructor() {
    super('Invalid guest token response');
  }
}
